
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","width":"271","height":"271","viewBox":"0 0 271.2 271.6","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M271.2 0h-68.3C202.7 112 112 202.9 0 203.3v68.3C149.7 271.2 271 149.8 271.2 0z","fill":"#fff"}})])
          )
        }
      }
    